import axios from 'axios'

import { toCamelCase } from '../helpers/utils'

export interface TruckListSetting {
  team?: string
  isOptedIn: boolean
}

export function getTruckListSetting(teamId: string): Promise<TruckListSetting> {
  const url = `/api/v3/truck-list-setting/${teamId}/`
  return axios.get(url).then((response) => toCamelCase(response.data) as TruckListSetting)
}

export function updateTruckListSetting(teamId: string, isOptedIn: boolean): Promise<TruckListSetting> {
  const url = `/api/v3/truck-list-setting/${teamId}/`
  return axios
    .patch(url, { is_opted_in: isOptedIn })
    .then((response) => toCamelCase(response.data) as TruckListSetting)
}
